import { render, staticRenderFns } from "./CourseType.vue?vue&type=template&id=647b9996&"
import script from "./CourseType.vue?vue&type=script&lang=js&"
export * from "./CourseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports